import React, { FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CompanyEditorFieldProps } from "../../CompanyEditor.types";

import { TextField, Typography } from "@components/base";

const OwnershipShare: FC<CompanyEditorFieldProps> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" color="text.secondary">
        {t("common.ownershipShare")}
      </Typography>
      <Controller
        name="ownershipSharePercentage"
        control={control}
        render={({ field }) => (
          <TextField
            type="number"
            variant="filled"
            fullWidth
            placeholder={t("common.ownershipShare")}
            value={field.value ?? ""}
            onChange={(e) =>
              field.onChange(
                e.target.value ? Number(e.target.value) : null,
              )
            }
          />
        )}
      />
    </>
  );
};

export default OwnershipShare;
